// services/smsConfigApi.js
import axios from "axios";

const BASE_URL = "https://sms.brightechsoftware.com/api/v1/sms-config";

// GET ALL
export const getSmsConfigs = async () => {
    const res = await axios.get(BASE_URL);
    return res.data;
};

// CREATE
export const createSmsConfig = async (data) => {
    const res = await axios.post(BASE_URL, data);
    return res.data;
};

// UPDATE
export const updateSmsConfig = async (id, data) => {
    const res = await axios.put(`${BASE_URL}/${id}`, data);
    return res.data;
};

// DELETE
export const deleteSmsConfig = async (id) => {
    const res = await axios.delete(`${BASE_URL}/${id}`);
    return res.data;
};